// extracted by mini-css-extract-plugin
export default {"multiboxComponent":"Multibox-module__multiboxComponent___2CQ7K","checkboxWrapper":"Multibox-module__checkboxWrapper___3G3C4"};